import React, {useState, useEffect} from 'react'
import NavBar from '../components/NavBar'
import DisplayCounter from '../components/DisplayCounter'
import AppNavBar from '../components/NavBar'





export default function Contact(props){

    return(

        <div>
            <h1> Contact page</h1>
            <DisplayCounter/>

        </div>
    )

}